import { CircularProgress } from "@/atoms";
import { strings } from "@/constants";
import { BenchmarkPageStatusEnum } from "@/enums";
import type { BenchmarkPageStatusType } from "@/types";

export const BenchmarkTitle = ({
    errorMessage,
    progress,
    status,
}: {
    errorMessage: string,
    progress: number,
    status: BenchmarkPageStatusType,
}) => {
    if (status === BenchmarkPageStatusEnum.IDLE) return null;

    if (status === BenchmarkPageStatusEnum.LOADING) {
        return (
            <>
                <h1
                    className="
                        text-gradient
                        mb-6
                        text-2xl
                        font-bold
                        sm:text-3xl
                    "
                >
                    {strings.benchmark.titleLoading}
                </h1>
                <div className="mb-8">
                    <CircularProgress progress={progress} />
                </div>
            </>
        );
    }

    if (status === BenchmarkPageStatusEnum.ERROR) {
        return (
            <div
                role="alert"
                className="
                    mx-auto
                    mb-6
                    flex
                    max-w-md
                    items-center
                    gap-2.5
                    rounded-full
                    border
                    border-error/20
                    bg-error/5
                    px-4
                    py-2
                    text-left
                    text-sm
                    text-error
                    shadow-[0_8px_20px_-12px_rgba(220,38,38,0.35)]
                "
            >
                <svg
                    className="h-4 w-4 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                    aria-hidden
                >
                    <path
                        d="M12 9v3m0 3.75h.008M10.34 3.94a1.92 1.92 0 013.32 0l8.4 14.55a1.92 1.92 0 01-1.66 2.88H3.6a1.92 1.92 0 01-1.66-2.88l8.4-14.55z"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                <span
                    className="
                        flex-1
                        text-xs
                        font-medium
                        sm:text-sm
                    "
                >
                    {errorMessage || strings.benchmark.errorDefault}
                </span>
            </div>
        );
    }

    return null;
};
